import { useCallback, useEffect, useRef, useState } from 'react'

import { Element } from 'react-scroll'

type PlayerContainer = Nullable<
  Element & HTMLDivElement & { childBindings: { domNode: HTMLDivElement } }
>

export const useIsBroadcastVisible = () => {
  const playerContainerRef = useRef<PlayerContainer>(null)

  const [isBroadcastVisible, setIsBroadcastVisible] = useState(true)

  const recalculate = useCallback(() => {
    const divElement = playerContainerRef.current?.childBindings.domNode
    const offsetParent = divElement?.offsetParent as Nullable<HTMLDivElement>
    if (!offsetParent || !divElement) {
      return
    }
    const scrollTop = offsetParent.scrollTop
    const scrollBottom = offsetParent.scrollTop + offsetParent.offsetHeight
    const offsetTop = divElement.offsetTop
    const offsetBottom = divElement.offsetTop + divElement.offsetHeight
    const nextState =
      scrollTop - offsetBottom < 0 && scrollBottom - offsetTop > 0

    setIsBroadcastVisible(nextState)
  }, [])

  useEffect(() => {
    recalculate()
  }, [recalculate])

  return {
    playerContainerRef: playerContainerRef,
    isBroadcastVisible,
    recalculate,
  }
}
